export default __webpack_public_path__ + "assets/img/article-cover.png";